module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Body-Text",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._v("Thrice tosse these Oaken ashes in the ayre,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Thrice sit thou mute in this inchanted chayre;")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Then thrice three times tye up this true loves knot,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("And murmur soft, shee will, or shee will not.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Goe burn these poys’nous weedes in yon blew fire,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("These Screech-owles fethers, and this prickling bryer,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("This Cypresse gathered at a dead mans grave:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("That all thy feares and cares an end may have.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Then come, you Fayries, dance with me a round,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Melt her hard heart with your melodious sound.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("In vaine are all the charmes I can devise:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("She hath an Arte to breake them with her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("—Thomas Campion, 1617")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145d3d50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled12.vue
// module id = 75
// module chunks = 0